import axios from "../utils/axios.wrapper";
 
export const getZones = async () => {
  const { data } = await axios.get("/zone");
  return data.items || data;
};
 
export const getActiveZones = async () => {
  const { data } = await axios.get("/zone/active");
  return data.items || data;
};
 
export const getZoneById = async (id) => {
  const { data } = await axios.get(`/zone/${id}`);
  return data;
};
 
export const getZoneByName = async (name) => {
  const { data } = await axios.get(`/zone/name/${name}`);
  return data;
};
 
export const createZone = async (zone) => {
  const { data } = await axios.post("/zone/create", zone);
  return data;
};
 
export const updateZone = async (id, zone) => {
  const { data } = await axios.put(`/zone/${id}`, zone);
  return data;
};
 
export const softDeleteZone = async (id) => {
  const { data } = await axios.patch(`/zone/${id}/soft-delete`);
  return data;
};
 
export const hardDeleteZone = async (id) => {
  const { data } = await axios.delete(`/zone/${id}`);
  return data;
};
 
// --- Waiter assignment ---
export const getZoneWaiters = async (zoneId) => {
  const { data } = await axios.get(`/zone/${zoneId}/waiters`);
  return data.items || data;
};
 
export const assignWaiterToZone = async (zoneId, userId) => {
  const { data } = await axios.post(`/zone/${zoneId}/waiters/${userId}`);
  return data;
};
 
export const removeWaiterFromZone = async (zoneId, userId) => {
  const { data } = await axios.delete(`/zone/${zoneId}/waiters/${userId}`);
  return data;
};
export const getZonesByShop = async (shopId) => {
  const { data } = await axios.get(`/zone/shop/${shopId}`);
  return data.items || data;
};
 
export const zoneService = {
  getZones,
  getActiveZones,
  getZoneById,
  getZoneByName,
  createZone,
  updateZone,
  softDeleteZone,
  hardDeleteZone,
  getZoneWaiters,
  assignWaiterToZone,
  removeWaiterFromZone,
  getZonesByShop,
};
 